/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApproveWorkflow } from '../models/ApproveWorkflow';
import type { ApproveWorkflowRequest } from '../models/ApproveWorkflowRequest';
// HAND-ADDED models for the process-engine endpoints (see hand-added methods
// below). Kept out of a full regenerate to avoid the backend/client schema drift.
import type { ApprovalLink, ApprovalLinkResult } from '../models/ApprovalLink';
import type { Rework } from '../models/Rework';
import type { ReworkRequest } from '../models/ReworkRequest';
import type { SubmitSection } from '../models/SubmitSection';
import type { SubmitSectionRequest } from '../models/SubmitSectionRequest';
import type { TemplateProcess, ProcessHistoryEntry, ProcessVersionRow, ProcessSimulation } from '../models/TemplateProcess';
import type { TemplateSetup } from '../models/TemplateSetup';
import type { RequestDocuments, TemplateDocument } from '../models/TemplateDocument';
import type { Report, ReportColumns, ReportRunResult, ReportSummaryResponse, RunReportRequest } from '../models/Report';
import type { AnalyticsDashboard } from '../models/Analytics';
import type { ProcessAnalytics } from '../models/ProcessAnalytics';
import type { CaseTimelineEntry } from '../models/CaseTimeline';
import type { Task, TaskListParams, TaskSummary } from '../models/Task';
import type { Delegation, DelegationWrite } from '../models/Delegation';
import type {
    AdminGroup,
    AdminUser,
    DirectoryGroupLink,
    DirectorySyncRun,
    IntegrationStatus,
    OrgUnit,
    OrgUnitNode,
    Location,
    LocationNode,
    LocationInUse,
    Position,
    SyncReport,
} from '../models/Organisation';
import type { SaveProcessRequest } from '../models/SaveProcessRequest';
import type { Attachment } from '../models/Attachment';
import type { AttachmentRequest } from '../models/AttachmentRequest';
import type { ChangeRequestOwner } from '../models/ChangeRequestOwner';
import type { ChangeRequestOwnerRequest } from '../models/ChangeRequestOwnerRequest';
import type { Control } from '../models/Control';
import type { CreateRequestComment } from '../models/CreateRequestComment';
import type { CreateRequestCommentRequest } from '../models/CreateRequestCommentRequest';
import type { CreateRequestForm } from '../models/CreateRequestForm';
import type { CreateRequestFormRequest } from '../models/CreateRequestFormRequest';
import type { Email } from '../models/Email';
import type { EmailRequest } from '../models/EmailRequest';
import type { ExtendRequest } from '../models/ExtendRequest';
import type { ExtendRequestRequest } from '../models/ExtendRequestRequest';
import type { FilterParameters } from '../models/FilterParameters';
import type { FilterParametersRequest } from '../models/FilterParametersRequest';
import type { Form } from '../models/Form';
import type { FormRequest } from '../models/FormRequest';
import type { GetMyRequests } from '../models/GetMyRequests';
import type { Group } from '../models/Group';
import type { GroupRequest } from '../models/GroupRequest';
import type { Hazard } from '../models/Hazard';
import type { HazardRequest } from '../models/HazardRequest';
import type { MyTokenObtainPair } from '../models/MyTokenObtainPair';
import type { MyTokenObtainPairRequest } from '../models/MyTokenObtainPairRequest';
import type { PasswordToken } from '../models/PasswordToken';
import type { PasswordTokenRequest } from '../models/PasswordTokenRequest';
import type { PatchedAttachmentRequest } from '../models/PatchedAttachmentRequest';
import type { PatchedFormRequest } from '../models/PatchedFormRequest';
import type { PatchedGroupRequest } from '../models/PatchedGroupRequest';
import type { PatchedHazardRequest } from '../models/PatchedHazardRequest';
import type { PatchedRequestApproverRequest } from '../models/PatchedRequestApproverRequest';
import type { PatchedRequestFormFieldValueRequest } from '../models/PatchedRequestFormFieldValueRequest';
import type { PatchedRequestRequest } from '../models/PatchedRequestRequest';
import type { PatchedTemplateRequest } from '../models/PatchedTemplateRequest';
import type { PatchedTemplateTypeRequest } from '../models/PatchedTemplateTypeRequest';
import type { PerformAction } from '../models/PerformAction';
import type { PerformActionRequest } from '../models/PerformActionRequest';
import type { Request } from '../models/Request';
import type { RequestApprover } from '../models/RequestApprover';
import type { RequestApproverRequest } from '../models/RequestApproverRequest';
import type { RequestComment } from '../models/RequestComment';
import type { RequestFormFieldValue } from '../models/RequestFormFieldValue';
import type { RequestFormFieldValueRequest } from '../models/RequestFormFieldValueRequest';
import type { RequestRequest } from '../models/RequestRequest';
import type { RequestsByRequestNumber } from '../models/RequestsByRequestNumber';
import type { ResetToken } from '../models/ResetToken';
import type { ResetTokenRequest } from '../models/ResetTokenRequest';
import type { WorkflowRole } from '../models/WorkflowRole';
import type { StartWorkflow } from '../models/StartWorkflow';
import type { StartWorkflowRequest } from '../models/StartWorkflowRequest';
import type { Template } from '../models/Template';
import type { TemplateRequest } from '../models/TemplateRequest';
import type { TemplateType } from '../models/TemplateType';
import type { TemplateTypeFilteredByGroups } from '../models/TemplateTypeFilteredByGroups';
import type { TemplateTypeRequest } from '../models/TemplateTypeRequest';
import type { TokenRefresh } from '../models/TokenRefresh';
import type { TokenRefreshRequest } from '../models/TokenRefreshRequest';
import type { User } from '../models/User';
import type { UserList } from '../models/UserList';
import type { ViewRequestApprover } from '../models/ViewRequestApprover';
import type { WorkOrder } from '../models/WorkOrder';
import type { WorksPlanRequests } from '../models/WorksPlanRequests';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApiService {

    /**
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsList(): CancelablePromise<Array<Group>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/groups/',
        });
    }

    /**
     * @param requestBody 
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsCreate(
requestBody: GroupRequest,
): CancelablePromise<Group> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/groups/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this group.
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsRetrieve(
id: number,
): CancelablePromise<Group> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/groups/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this group.
     * @param requestBody 
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsUpdate(
id: number,
requestBody: GroupRequest,
): CancelablePromise<Group> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounts/groups/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this group.
     * @param requestBody 
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsPartialUpdate(
id: number,
requestBody?: PatchedGroupRequest,
): CancelablePromise<Group> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/accounts/groups/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this group.
     * @returns void 
     * @throws ApiError
     */
    public static apiAccountsGroupsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/groups/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Takes a set of user credentials and returns an access and refresh JSON web
 * token pair to prove the authentication of those credentials.
     * @param requestBody 
     * @returns MyTokenObtainPair 
     * @throws ApiError
     */
    public static apiAccountsLoginCreate(
requestBody: MyTokenObtainPairRequest,
): CancelablePromise<MyTokenObtainPair> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/login/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web
 * token if the refresh token is valid.
     * @param requestBody 
     * @returns TokenRefresh 
     * @throws ApiError
     */
    public static apiAccountsRefreshTokenCreate(
requestBody: TokenRefreshRequest,
): CancelablePromise<TokenRefresh> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/refresh_token/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static apiAccountsRegisterCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/register/',
        });
    }

    /**
     * @param search A search term.
     * @returns UserList 
     * @throws ApiError
     */
    public static apiAccountsUsersList(
search?: string,
group?: number | null,
): CancelablePromise<Array<UserList>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/users/',
            query: {
                'search': search,
                // HAND-EDITED: restricts the directory to one Group, used by the
                // approver picker when a role slot has a pool.
                'group': group,
            },
        });
    }

    /**
     * @param id A UUID string identifying this custom user.
     * @returns User 
     * @throws ApiError
     */
    public static apiAccountsUsersRetrieve(
id: string,
): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/users/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param hazardId 
     * @param search 
     * @returns Control 
     * @throws ApiError
     */
    public static apiAssessmentGetControlsByQueryList(
hazardId: number,
search?: string,
): CancelablePromise<Array<Control>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/get-controls-by-query/',
            query: {
                'hazard_id': hazardId,
                'search': search,
            },
        });
    }

    /**
     * @param search 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentGetHazardsByQueryList(
search: string,
): CancelablePromise<Array<Hazard>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/get-hazards-by-query/',
            query: {
                'search': search,
            },
        });
    }

    /**
     * @param formId 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentGetHazardsList(
formId: number,
): CancelablePromise<Array<Hazard>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/get-hazards/{form_id}/',
            path: {
                'form_id': formId,
            },
        });
    }

    /**
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsList(): CancelablePromise<Array<Hazard>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/hazards/',
        });
    }

    /**
     * @param requestBody 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsCreate(
requestBody: HazardRequest,
): CancelablePromise<Hazard> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assessment/hazards/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this hazard.
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsRetrieve(
id: number,
): CancelablePromise<Hazard> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/hazards/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this hazard.
     * @param requestBody 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsUpdate(
id: number,
requestBody: HazardRequest,
): CancelablePromise<Hazard> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assessment/hazards/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this hazard.
     * @param requestBody 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsPartialUpdate(
id: number,
requestBody?: PatchedHazardRequest,
): CancelablePromise<Hazard> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assessment/hazards/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this hazard.
     * @returns void 
     * @throws ApiError
     */
    public static apiAssessmentHazardsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assessment/hazards/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param hazardId 
     * @returns Control 
     * @throws ApiError
     */
    public static apiAssessmentLastFiveControlsList(
hazardId: number,
): CancelablePromise<Array<Control>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/last-five-controls/',
            query: {
                'hazard_id': hazardId,
            },
        });
    }

    /**
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentLastFiveHazardsList(): CancelablePromise<Array<Hazard>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/last-five-hazards/',
        });
    }

    /**
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsList(): CancelablePromise<Array<Attachment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/attachments/',
        });
    }

    /**
     * @param requestBody 
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsCreate(
requestBody: AttachmentRequest,
): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/attachments/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this attachment.
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsRetrieve(
id: number,
): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/attachments/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this attachment.
     * @param requestBody 
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsUpdate(
id: number,
requestBody: AttachmentRequest,
): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/attachments/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this attachment.
     * @param requestBody 
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsPartialUpdate(
id: number,
requestBody?: PatchedAttachmentRequest,
): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/attachments/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this attachment.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainAttachmentsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/attachments/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ChangeRequestOwner 
     * @throws ApiError
     */
    public static apiMainChangeRequestOwnerCreate(
requestBody: ChangeRequestOwnerRequest,
): CancelablePromise<ChangeRequestOwner> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/change-request-owner/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody 
     * @returns CreateRequestComment 
     * @throws ApiError
     */
    public static apiMainCreateRequestCommentCreate(
requestBody: CreateRequestCommentRequest,
): CancelablePromise<CreateRequestComment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/create-request-comment/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainDownloadDocumentRetrieve(
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/download-document/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ExtendRequest 
     * @throws ApiError
     */
    public static apiMainExtendRequestCreate(
requestBody: ExtendRequestRequest,
): CancelablePromise<ExtendRequest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/extend-request/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesList(): CancelablePromise<Array<RequestFormFieldValue>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/form-field-values/',
        });
    }

    /**
     * @param requestBody 
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesCreate(
requestBody: RequestFormFieldValueRequest,
): CancelablePromise<RequestFormFieldValue> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/form-field-values/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request form field value.
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesRetrieve(
id: number,
): CancelablePromise<RequestFormFieldValue> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/form-field-values/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this request form field value.
     * @param requestBody 
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesUpdate(
id: number,
requestBody: RequestFormFieldValueRequest,
): CancelablePromise<RequestFormFieldValue> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/form-field-values/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request form field value.
     * @param requestBody 
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesPartialUpdate(
id: number,
requestBody?: PatchedRequestFormFieldValueRequest,
): CancelablePromise<RequestFormFieldValue> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/form-field-values/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request form field value.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/form-field-values/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsList(): CancelablePromise<Array<Form>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/forms/',
        });
    }

    /**
     * @param requestBody 
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsCreate(
requestBody: FormRequest,
): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/forms/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this form.
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsRetrieve(
id: number,
): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/forms/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this form.
     * @param requestBody 
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsUpdate(
id: number,
requestBody: FormRequest,
): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/forms/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this form.
     * @param requestBody 
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsPartialUpdate(
id: number,
requestBody?: PatchedFormRequest,
): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/forms/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this form.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainFormsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/forms/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainGenerateDocumentRetrieve(
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/generate-document/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainGetRequestCmsRetrieve(
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/get-request-cms/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainGetRequestDocRetrieve(
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/get-request-doc/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @param search 
     * @returns RequestsByRequestNumber 
     * @throws ApiError
     */
    public static apiMainGetRequestsByNumberList(
search: string,
): CancelablePromise<Array<RequestsByRequestNumber>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/get-requests-by-number/',
            query: {
                'search': search,
            },
        });
    }

    /**
     * @returns GetMyRequests 
     * @throws ApiError
     */
    public static apiMainLast10RequestsList(): CancelablePromise<Array<GetMyRequests>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/last-10-requests/',
        });
    }

    /**
     * @param requestId 
     * @returns RequestComment 
     * @throws ApiError
     */
    public static apiMainListRequestCommentsList(
requestId: number,
): CancelablePromise<Array<RequestComment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/list-request-comments/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @returns GetMyRequests 
     * @throws ApiError
     */
    public static apiMainMyRequestsList(
filters?: Record<string, any>,
): CancelablePromise<Array<GetMyRequests>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/my-requests/',
            query: filters,
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static apiMainRequestStatusesList(): CancelablePromise<Array<{ id: string; name: string }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-statuses/',
        });
    }

    /**
     * @param requestBody 
     * @returns PerformAction 
     * @throws ApiError
     */
    public static apiMainPerformActionCreate(
requestBody: PerformActionRequest,
): CancelablePromise<PerformAction> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/perform-action/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversList(): CancelablePromise<Array<RequestApprover>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-approvers/',
        });
    }

    /**
     * @param requestBody 
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversCreate(
requestBody: RequestApproverRequest,
): CancelablePromise<RequestApprover> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-approvers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request approver.
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversRetrieve(
id: number,
): CancelablePromise<RequestApprover> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-approvers/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this request approver.
     * @param requestBody 
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversUpdate(
id: number,
requestBody: RequestApproverRequest,
): CancelablePromise<RequestApprover> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/request-approvers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request approver.
     * @param requestBody 
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversPartialUpdate(
id: number,
requestBody?: PatchedRequestApproverRequest,
): CancelablePromise<RequestApprover> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/request-approvers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request approver.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainRequestApproversDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/request-approvers/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestId 
     * @param workflowId 
     * @returns ViewRequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversGetApproversList(
requestId: string,
workflowId: number,
): CancelablePromise<Array<ViewRequestApprover>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-approvers/get_approvers/',
            query: {
                'request_id': requestId,
                'workflow_id': workflowId,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns CreateRequestForm 
     * @throws ApiError
     */
    public static apiMainRequestFormCreate(
requestBody: CreateRequestFormRequest,
): CancelablePromise<CreateRequestForm> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-form/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param formId 
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainRequestFormRetrieve(
formId: number,
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-form/{request_id}/{form_id}/',
            path: {
                'form_id': formId,
                'request_id': requestId,
            },
        });
    }

    /**
     * @param id 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainRequestHistoryRetrieve(
id: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-history/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ApproveWorkflow 
     * @throws ApiError
     */
    public static apiMainRequestWorkflowApproveCreate(
requestBody: ApproveWorkflowRequest,
): CancelablePromise<ApproveWorkflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-workflow/approve/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody 
     * @returns ApproveWorkflow 
     * @throws ApiError
     */
    public static apiMainRequestWorkflowRejectCreate(
requestBody: ApproveWorkflowRequest,
): CancelablePromise<ApproveWorkflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-workflow/reject/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: return a permit to Draft for correction with a required reason.
     * @param requestBody
     * @returns Rework
     * @throws ApiError
     */
    public static apiMainRequestWorkflowReworkCreate(
requestBody: ReworkRequest,
): CancelablePromise<Rework> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-workflow/rework/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: describe the approval a mailed link points at. Read-only —
     * it must stay safe for a mail scanner to fetch, so it never approves.
     * @param token
     * @returns ApprovalLink
     * @throws ApiError
     */
    public static apiMainApprovalLinkRetrieve(
token: string,
): CancelablePromise<ApprovalLink> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/approval-link/{token}/',
            path: {
                'token': token,
            },
        });
    }

    /**
     * HAND-ADDED: give the approval the link was minted for. Single use.
     * The signer is the person the token belongs to — this endpoint has no
     * authenticated caller and takes no identity from the body.
     * @param token
     * @returns ApprovalLinkResult
     * @throws ApiError
     */
    public static apiMainApprovalLinkCreate(
token: string,
): CancelablePromise<ApprovalLinkResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/approval-link/{token}/',
            path: {
                'token': token,
            },
        });
    }

    /**
     * HAND-ADDED: mark a section submitted (done) or reopen it.
     * @param requestBody
     * @returns SubmitSection
     * @throws ApiError
     */
    public static apiMainRequestSectionSubmitCreate(
requestBody: SubmitSectionRequest,
): CancelablePromise<SubmitSection> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-section/submit/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: a template's whole process layout — stages, section
     * properties and approval slots. Template admins only.
     * @param templateId
     * @returns TemplateProcess
     * @throws ApiError
     */
    public static apiMainTemplateProcessRetrieve(
templateId: number,
): CancelablePromise<TemplateProcess> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/templates/{template_id}/process/',
            path: {
                'template_id': templateId,
            },
        });
    }

    /**
     * HAND-ADDED: save the whole process layout in one transaction. A layout
     * that fails validation is refused whole, with 400 {message, problems}.
     * @param templateId
     * @param requestBody
     * @returns TemplateProcess the layout as saved
     * @throws ApiError
     */
    public static apiMainTemplateProcessUpdate(
templateId: number,
requestBody: SaveProcessRequest,
): CancelablePromise<TemplateProcess> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/templates/{template_id}/process/',
            path: {
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: publish the current layout so new permits pick it up.
     * Idempotent — publishing an unchanged layout returns the current version.
     * @param templateId
     * @returns TemplateProcess
     * @throws ApiError
     */
    public static apiMainTemplateProcessPublishCreate(
templateId: number,
): CancelablePromise<TemplateProcess> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/templates/{template_id}/process/publish/',
            path: {
                'template_id': templateId,
            },
            body: {},
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: who changed this template's process, when, and what moved.
     * @param templateId
     * @throws ApiError
     */
    public static apiMainTemplateProcessHistoryRetrieve(
templateId: number,
): CancelablePromise<{ entries: ProcessHistoryEntry[] }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/templates/{template_id}/process/history/',
            path: {
                'template_id': templateId,
            },
        });
    }

    /**
     * HAND-ADDED: the published versions, each with what it changed.
     * @param templateId
     * @throws ApiError
     */
    public static apiMainTemplateProcessVersionsRetrieve(
templateId: number,
): CancelablePromise<{ versions: ProcessVersionRow[]; current: number | null }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/templates/{template_id}/process/versions/',
            path: {
                'template_id': templateId,
            },
        });
    }

    /**
     * HAND-ADDED: put an earlier published layout back in place.
     * @param templateId
     * @param version
     * @param requestBody
     * @returns TemplateProcess
     * @throws ApiError
     */
    public static apiMainTemplateProcessRestoreCreate(
templateId: number,
version: number,
requestBody: { publish?: boolean; base_revision?: string | null },
): CancelablePromise<TemplateProcess> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/templates/{template_id}/process/versions/{version}/restore/',
            path: {
                'template_id': templateId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: withdraw a case — the requester's own escape hatch.
     *
     * NOT `requests/withdraw/`: the DRF router owns `requests/<pk>/` and would
     * match "withdraw" as an id, answering 405.
     * @param requestBody
     * @throws ApiError
     */
    public static apiMainRequestWithdrawCreate(
requestBody: {
    request_id: number;
    /** Required. A cancelled case with no reason is a hole in the record. */
    reason: string;
},
): CancelablePromise<{ message: string; status: string }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-withdraw/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: try sample answers against the conditions on the steps, the
     * sections and the signature slots, without touching anything.
     * @param templateId
     * @param requestBody
     * @returns ProcessSimulation
     * @throws ApiError
     */
    public static apiMainTemplateProcessSimulateCreate(
templateId: number,
requestBody: {
    values: Record<string, any>;
    /** The unsaved layout to try. Omitted, the saved process is tried. */
    stages?: Array<{ key: string; name: string; kind: string; condition: Record<string, any> }>;
    sections?: Array<{ id: number | null; title: string; condition: Record<string, any> }>;
    /** `assignment` + `resolver` let a slot switched to a derived mode in the
     *  draft be previewed before it is saved — which is the whole point of
     *  Try it. Without them the preview would route against the saved slot. */
    slots?: Array<{ id: number | null; title: string; workflow_name: string; condition: Record<string, any>; assignment?: string; resolver?: Record<string, any> }>;
},
): CancelablePromise<ProcessSimulation> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/templates/{template_id}/process/simulate/',
            path: {
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: the named signature slots for one approval stage.
     * Empty array = legacy stage (pick any N users).
     * @param workflowId
     * @returns WorkflowRole
     * @throws ApiError
     */
    public static apiMainWorkflowRolesList(
workflowId: number,
): CancelablePromise<Array<WorkflowRole>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/workflow-roles/{workflow_id}/',
            path: {
                'workflow_id': workflowId,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns StartWorkflow 
     * @throws ApiError
     */
    public static apiMainRequestWorkflowStartCreate(
requestBody: StartWorkflowRequest,
): CancelablePromise<StartWorkflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-workflow/start/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param shortName 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainRequestStatusesByShortNameRetrieve(
shortName: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request_statuses_by_short_name/{short_name}/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * @param templateId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainRequestStatusesByTemplateRetrieve(
templateId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request_statuses_by_template/{template_id}/',
            path: {
                'template_id': templateId,
            },
        });
    }

    /**
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsList(
filters?: Record<string, any>,
): CancelablePromise<Array<Request>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/requests/',
            query: filters,
        });
    }

    /**
     * @param requestBody 
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsCreate(
requestBody: RequestRequest,
): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/requests/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody 
     * @returns FilterParameters 
     * @throws ApiError
     */
    public static apiMainRequestsByTemplateCreate(
requestBody: FilterParametersRequest,
): CancelablePromise<FilterParameters> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/requests-by-template/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request.
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsRetrieve(
id: number,
): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/requests/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this request.
     * @param requestBody 
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsUpdate(
id: number,
requestBody: RequestRequest,
): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/requests/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request.
     * @param requestBody 
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsPartialUpdate(
id: number,
requestBody?: PatchedRequestRequest,
): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/requests/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainRequestsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/requests/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param userId 
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsGetRequestsForApprovalList(
userId: string,
filters?: Record<string, any>,
): CancelablePromise<Array<Request>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/requests/get_requests_for_approval/',
            query: {
                'user_id': userId,
                ...(filters || {}),
            },
        });
    }

    /**
     * @param shortName 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainSearchFieldsByTemplateRetrieve(
shortName: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/search-fields-by-template/{short_name}/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainStatusRequestCountRetrieve(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/status-request-count/',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainTemplateRequestCountRetrieve(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/template-request-count/',
        });
    }

    /**
     * @param type 
     * @returns TemplateTypeFilteredByGroups 
     * @throws ApiError
     */
    public static apiMainTemplateTypesList(
type: string,
): CancelablePromise<Array<TemplateTypeFilteredByGroups>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/template-types/',
            query: {
                'type': type,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns TemplateType 
     * @throws ApiError
     */
    public static apiMainTemplateTypesCreate(
requestBody: TemplateTypeRequest,
): CancelablePromise<TemplateType> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/template-types/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this template type.
     * @returns TemplateType 
     * @throws ApiError
     */
    public static apiMainTemplateTypesRetrieve(
id: number,
): CancelablePromise<TemplateType> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/template-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this template type.
     * @param requestBody 
     * @returns TemplateType 
     * @throws ApiError
     */
    public static apiMainTemplateTypesUpdate(
id: number,
requestBody: TemplateTypeRequest,
): CancelablePromise<TemplateType> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/template-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this template type.
     * @param requestBody 
     * @returns TemplateType 
     * @throws ApiError
     */
    public static apiMainTemplateTypesPartialUpdate(
id: number,
requestBody?: PatchedTemplateTypeRequest,
): CancelablePromise<TemplateType> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/template-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this template type.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainTemplateTypesDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/template-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesList(): CancelablePromise<Array<Template>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/templates/',
        });
    }

    /**
     * @param requestBody 
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesCreate(
requestBody: TemplateRequest,
): CancelablePromise<Template> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/templates/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param shortName 
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesRetrieve(
shortName: string,
): CancelablePromise<Template> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/templates/{short_name}/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * @param shortName 
     * @param requestBody 
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesUpdate(
shortName: string,
requestBody: TemplateRequest,
): CancelablePromise<Template> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/templates/{short_name}/',
            path: {
                'short_name': shortName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param shortName 
     * @param requestBody 
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesPartialUpdate(
shortName: string,
requestBody?: PatchedTemplateRequest,
): CancelablePromise<Template> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/templates/{short_name}/',
            path: {
                'short_name': shortName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param shortName 
     * @returns void 
     * @throws ApiError
     */
    public static apiMainTemplatesDestroy(
shortName: string,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/templates/{short_name}/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainTotalCountsRetrieve(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/total-counts/',
        });
    }

    /**
     * @returns WorksPlanRequests 
     * @throws ApiError
     */
    public static apiMainWorksPlanRequestsList(): CancelablePromise<Array<WorksPlanRequests>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/works-plan-requests/',
        });
    }

    /**
     * An Api View which provides a method to request a password reset token based on an e-mail address
 *
 * Sends a signal reset_password_token_created when a reset token was created
     * @param requestBody 
     * @returns Email 
     * @throws ApiError
     */
    public static apiPasswordResetCreate(
requestBody: EmailRequest,
): CancelablePromise<Email> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/password_reset/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * An Api View which provides a method to reset a password based on a unique token
     * @param requestBody 
     * @returns PasswordToken 
     * @throws ApiError
     */
    public static apiPasswordResetConfirmCreate(
requestBody: PasswordTokenRequest,
): CancelablePromise<PasswordToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/password_reset/confirm/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * An Api View which provides a method to verify that a token is valid
     * @param requestBody 
     * @returns ResetToken 
     * @throws ApiError
     */
    public static apiPasswordResetValidateTokenCreate(
requestBody: ResetTokenRequest,
): CancelablePromise<ResetToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/password_reset/validate_token/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param endDate 
     * @param location 
     * @param startDate 
     * @returns Request 
     * @throws ApiError
     */
    public static apiSimopsNearbyRequestList(
endDate: string,
location: string,
startDate: string,
): CancelablePromise<Array<Request>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/simops/nearby_request/',
            query: {
                'end_date': endDate,
                'location': location,
                'start_date': startDate,
            },
        });
    }

    /**
     * @param number 
     * @returns WorkOrder 
     * @throws ApiError
     */
    public static apiWorkordersGetWorkorderRetrieve(
number: string,
): CancelablePromise<WorkOrder> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/workorders/get-workorder/{number}/',
            path: {
                'number': number,
            },
        });
    }

    /**
     * @param search 
     * @returns WorkOrder 
     * @throws ApiError
     */
    public static apiWorkordersGetWorkordersList(
search?: string,
): CancelablePromise<Array<WorkOrder>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/workorders/get-workorders/',
            query: {
                'search': search,
            },
        });
    }

    /**
     * HAND-ADDED: create a bare template. The generated `apiMainTemplatesCreate`
     * demands nested sections and approvals, which a new template has none of.
     * @param requestBody
     * @throws ApiError
     */
    public static apiMainTemplateCreate(
requestBody: {
    name: string;
    short_name: string;
    template_type: number;
    view_type?: string;
    admins?: number | null;
    users?: number | null;
},
): CancelablePromise<{ id: number; name: string; short_name: string }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/templates/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: how far a template is from being usable.
     * @param shortName
     * @throws ApiError
     */
    public static apiMainTemplateSetupRetrieve(
shortName: string,
): CancelablePromise<TemplateSetup> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/templates/{short_name}/setup/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * HAND-ADDED: a form's version history, newest first (no schema payload).
     * @param formId
     * @throws ApiError
     */
    public static apiMainFormVersionsList(
formId: number,
): CancelablePromise<Array<{ version: number; is_published: boolean; note?: string; created_at?: string; created_by_name?: string }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/forms/{form_id}/versions/',
            path: {
                'form_id': formId,
            },
        });
    }

    /**
     * HAND-ADDED: save the working draft of a form's schema, optionally
     * publishing it. Repeated saves update the same draft version rather than
     * piling up new ones.
     * @param formId
     * @param requestBody
     * @throws ApiError
     */
    public static apiMainFormVersionsCreate(
formId: number,
requestBody: { schema_json: any; note?: string; publish?: boolean },
): CancelablePromise<{ version: number; is_published: boolean; schema_json: any }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/forms/{form_id}/versions/',
            path: {
                'form_id': formId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: one version's full payload, schema included.
     * @param formId
     * @param version
     * @throws ApiError
     */
    public static apiMainFormVersionRetrieve(
formId: number,
version: number,
): CancelablePromise<{ version: number; is_published: boolean; schema_json: any }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/forms/{form_id}/versions/{version}/',
            path: {
                'form_id': formId,
                'version': version,
            },
        });
    }

    /**
     * HAND-ADDED: everything the Analytics page draws, in one call.
     *
     * One endpoint rather than the four the old dashboard used: every figure on
     * that page has to agree about which window it covers, and separately
     * parameterised calls are separate chances for the KPI row and the chart
     * under it to be counting different things with nothing on screen saying so.
     * `range` comes back resolved, so the page states the window it is showing.
     * @param dateFrom YYYY-MM-DD, inclusive. Omitted = the last 30 days.
     * @param dateTo YYYY-MM-DD, inclusive.
     * @param template narrow to one process. Omitted = every process the caller may see.
     * @returns AnalyticsDashboard
     * @throws ApiError
     */
    public static apiMainAnalyticsDashboardRetrieve(
dateFrom?: string,
dateTo?: string,
template?: number,
): CancelablePromise<AnalyticsDashboard> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/analytics/dashboard/',
            query: {
                'from': dateFrom,
                'to': dateTo,
                'template': template,
            },
        });
    }

    /**
     * HAND-ADDED: where a process is slow, and who is slow in it.
     *
     * Its own endpoint rather than more keys on the dashboard: it answers a
     * different question over a different default window (90 days, because a
     * process with a two-week cycle has almost no finished steps inside a
     * month), and two windows in one payload is the confusion the single
     * dashboard call exists to avoid.
     * @param dateFrom YYYY-MM-DD, inclusive. Omitted = the last 90 days.
     * @param dateTo YYYY-MM-DD, inclusive.
     * @param template narrow to one process.
     * @returns ProcessAnalytics
     * @throws ApiError
     */
    public static apiMainAnalyticsProcessRetrieve(
dateFrom?: string,
dateTo?: string,
template?: number,
): CancelablePromise<ProcessAnalytics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/analytics/process/',
            query: {
                'from': dateFrom,
                'to': dateTo,
                'template': template,
            },
        });
    }

    /**
     * HAND-ADDED: the whole story of one case, merged from the audit log, the
     * comments, the section submissions and the signatures.
     *
     * Merged on the server: three lists paged separately cannot be interleaved
     * correctly by a client without fetching all of each, which is what paging
     * exists to avoid.
     * @param requestId
     * @returns the entries, oldest first
     * @throws ApiError
     */
    public static apiMainRequestTimelineRetrieve(
requestId: number,
): CancelablePromise<{ entries: CaseTimelineEntry[] }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-timeline/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * HAND-ADDED: a full copy of one process under a new short name.
     * @param templateId
     * @param requestBody
     * @throws ApiError
     */
    public static apiMainTemplateCloneCreate(
templateId: number,
requestBody: { short_name: string; name?: string },
): CancelablePromise<{ id: number; short_name: string; name: string; warnings: string[] }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/templates/{template_id}/clone/',
            path: {
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: build a process from an exported document.
     *
     * NOT `templates/import/`: the DRF router owns `templates/<pk>/` and would
     * match "import" as an id.
     * @param requestBody
     * @throws ApiError
     */
    public static apiMainTemplateImportCreate(
requestBody: { process: any; short_name?: string; name?: string },
): CancelablePromise<{ id: number; short_name: string; name: string; warnings: string[] }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/template-import/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: which documents a permit can print, and in which formats.
     * The Actions menu is built from this.
     * @param requestId
     * @returns RequestDocuments
     * @throws ApiError
     */
    public static apiMainRequestDocumentsRetrieve(
requestId: number,
): CancelablePromise<RequestDocuments> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-documents/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * HAND-ADDED: a template's named documents, in menu order.
     * @param templateId
     * @returns TemplateDocument
     * @throws ApiError
     */
    public static apiMainTemplateDocumentsList(
templateId: number,
): CancelablePromise<Array<TemplateDocument>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/template-documents/',
            query: {
                'template': templateId,
            },
        });
    }

    /**
     * HAND-ADDED: upload a new document for a template. Multipart — `file` is
     * the .docx itself. Order is assigned by the server (appended to the end).
     * @param formData
     * @returns TemplateDocument
     * @throws ApiError
     */
    public static apiMainTemplateDocumentsCreate(
formData: { template: number; name: string; file: Blob },
): CancelablePromise<TemplateDocument> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/template-documents/',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * HAND-ADDED: rename a document, or replace the .docx behind it.
     * @param id
     * @param formData
     * @returns TemplateDocument
     * @throws ApiError
     */
    public static apiMainTemplateDocumentsPartialUpdate(
id: number,
formData: { name?: string; file?: Blob },
): CancelablePromise<TemplateDocument> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/template-documents/{id}/',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * HAND-ADDED: remove a document from the menu. Deactivates rather than
     * deletes — permits printed from it still exist.
     * @param id
     * @throws ApiError
     */
    public static apiMainTemplateDocumentsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/template-documents/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * HAND-ADDED: renumber a template's documents from list position.
     * @param requestBody
     * @returns TemplateDocument the list as saved
     * @throws ApiError
     */
    public static apiMainTemplateDocumentsReorder(
requestBody: { template: number; ids: Array<number> },
): CancelablePromise<Array<TemplateDocument>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/template-documents/reorder/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: the saved reports, optionally for one template.
     * @param templateId
     * @returns Report
     * @throws ApiError
     */
    public static apiMainReportsList(
templateId?: number,
): CancelablePromise<Array<Report>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/reports/',
            query: {
                'template': templateId,
            },
        });
    }

    /**
     * HAND-ADDED: one saved report.
     * @param id
     * @returns Report
     * @throws ApiError
     */
    public static apiMainReportsRetrieve(
id: number,
): CancelablePromise<Report> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/reports/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * HAND-ADDED: define a report. Template admins only.
     * @param requestBody
     * @returns Report
     * @throws ApiError
     */
    public static apiMainReportsCreate(
requestBody: Partial<Report>,
): CancelablePromise<Report> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/reports/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: change a report's name, columns or filters.
     * @param id
     * @param requestBody
     * @returns Report
     * @throws ApiError
     */
    public static apiMainReportsPartialUpdate(
id: number,
requestBody: Partial<Report>,
): CancelablePromise<Report> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/reports/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: retire a report (deactivates, never deletes).
     * @param id
     * @throws ApiError
     */
    public static apiMainReportsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/reports/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * HAND-ADDED: everything a template can put in a report — core request
     * columns plus every section's fields, with their human labels.
     * @param templateId
     * @returns ReportColumns
     * @throws ApiError
     */
    public static apiMainReportsColumns(
templateId: number,
): CancelablePromise<ReportColumns> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/reports/columns/',
            query: {
                'template': templateId,
            },
        });
    }

    /**
     * HAND-ADDED: run a report. Rows are scoped to the caller, not the author.
     * @param id
     * @param requestBody
     * @returns ReportRunResult
     * @throws ApiError
     */
    public static apiMainReportsRun(
id: number,
requestBody: RunReportRequest,
): CancelablePromise<ReportRunResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/reports/{id}/run/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: the same rows rolled up by the report's grouping dimension.
     * Answers `{grouped: false}` for a report that is a flat list.
     * @param id
     * @param requestBody
     * @returns ReportSummaryResponse
     * @throws ApiError
     */
    public static apiMainReportsSummary(
id: number,
requestBody: RunReportRequest,
): CancelablePromise<ReportSummaryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/reports/{id}/summary/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    // ---- administration: people, groups, the organisation -------------------
    // HAND-ADDED, under /api/accounts/admin/. Everything below is staff-only
    // and exists so a customer's administrator never needs a Django admin
    // login -- which, being a superuser login over every model in the project,
    // is not a thing to hand out for adding a starter.

    /**
     * HAND-ADDED: people, including deactivated ones.
     * Unlike the picker's `users/`, this lists inactive accounts too -- finding
     * one and switching it back on is most of why the screen exists.
     * @param params search / is_active / group / org_unit / no_manager
     * @returns AdminUser
     * @throws ApiError
     */
    public static apiAccountsAdminUsersList(
params?: { search?: string; is_active?: string; group?: number; org_unit?: number; no_manager?: string },
): CancelablePromise<AdminUser[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/users/',
            query: params as Record<string, any>,
        });
    }

    /**
     * HAND-ADDED: create a person. No password means no *usable* password --
     * a directory account signs in through the directory.
     * @param requestBody
     * @returns AdminUser
     * @throws ApiError
     */
    public static apiAccountsAdminUsersCreate(
requestBody: Partial<AdminUser> & { password?: string },
): CancelablePromise<AdminUser> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/admin/users/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: edit a person. `email` is ignored -- it is the login and the
     * key a directory sync matches on, so changing it is a migration.
     * @param id
     * @param requestBody
     * @returns AdminUser
     * @throws ApiError
     */
    public static apiAccountsAdminUsersPartialUpdate(
id: string,
requestBody: Partial<AdminUser>,
): CancelablePromise<AdminUser> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/accounts/admin/users/{id}/',
            path: { 'id': id },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: deactivate a person. Nothing is deleted (invariant 2) --
     * they authored audit rows and signed permits.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiAccountsAdminUsersDeactivate(
id: string,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/admin/users/{id}/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: switch a deactivated person back on.
     * @param id
     * @returns AdminUser
     * @throws ApiError
     */
    public static apiAccountsAdminUsersActivate(
id: string,
): CancelablePromise<AdminUser> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/admin/users/{id}/activate/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: set somebody's password. Checked against Django's own
     * validators, so the rules match the rest of the product.
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static apiAccountsAdminUsersSetPassword(
id: string,
requestBody: { new_password: string },
): CancelablePromise<{ detail: string }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/admin/users/{id}/set-password/',
            path: { 'id': id },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: groups, with what each one is used by.
     * @param search
     * @returns AdminGroup
     * @throws ApiError
     */
    public static apiAccountsAdminGroupsList(
search?: string,
): CancelablePromise<AdminGroup[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/groups/',
            query: { 'search': search },
        });
    }

    /**
     * HAND-ADDED: create a group.
     * @param requestBody
     * @returns AdminGroup
     * @throws ApiError
     */
    public static apiAccountsAdminGroupsCreate(
requestBody: { name: string },
): CancelablePromise<AdminGroup> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/admin/groups/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: rename a group.
     * @param id
     * @param requestBody
     * @returns AdminGroup
     * @throws ApiError
     */
    public static apiAccountsAdminGroupsPartialUpdate(
id: number,
requestBody: { name: string },
): CancelablePromise<AdminGroup> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/accounts/admin/groups/{id}/',
            path: { 'id': id },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: delete a group. Refused with a reason when an approval slot
     * or a template points at it.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiAccountsAdminGroupsDelete(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/admin/groups/{id}/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: who is in a group.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiAccountsAdminGroupMembers(
id: number,
): CancelablePromise<Array<{ id: string; name: string; email: string }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/groups/{id}/members/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: replace a group's membership. Refused for a
     * directory-managed group -- that edit would last until the next sync.
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static apiAccountsAdminSetGroupMembers(
id: number,
requestBody: { user_ids: string[] },
): CancelablePromise<{ detail: string }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounts/admin/groups/{id}/members/',
            path: { 'id': id },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: organisation units, flat.
     * @param search
     * @returns OrgUnit
     * @throws ApiError
     */
    public static apiAccountsOrgUnitsList(
search?: string,
): CancelablePromise<OrgUnit[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/org-units/',
            query: { 'search': search },
        });
    }

    /**
     * HAND-ADDED: the whole org chart, nested, in one call. One call rather
     * than a lazy load per node: a screen that fetches to expand cannot search
     * across what it has not fetched.
     * @returns OrgUnitNode
     * @throws ApiError
     */
    public static apiAccountsOrgUnitsTree(): CancelablePromise<OrgUnitNode[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/org-units/tree/',
        });
    }

    /**
     * HAND-ADDED: create an organisation unit.
     * @param requestBody
     * @returns OrgUnit
     * @throws ApiError
     */
    public static apiAccountsOrgUnitsCreate(
requestBody: Partial<OrgUnit>,
): CancelablePromise<OrgUnit> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/admin/org-units/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: edit an organisation unit.
     * @param id
     * @param requestBody
     * @returns OrgUnit
     * @throws ApiError
     */
    public static apiAccountsOrgUnitsPartialUpdate(
id: number,
requestBody: Partial<OrgUnit>,
): CancelablePromise<OrgUnit> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/accounts/admin/org-units/{id}/',
            path: { 'id': id },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: retire an organisation unit. Deactivates; nothing is deleted.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiAccountsOrgUnitsDelete(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/admin/org-units/{id}/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: places, flat.
     * @param search
     * @returns Location
     * @throws ApiError
     */
    public static apiAccountsLocationsList(
search?: string,
): CancelablePromise<Location[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/locations/',
            query: { 'search': search },
        });
    }

    /**
     * HAND-ADDED: every place, nested, in one call.
     * @returns LocationNode
     * @throws ApiError
     */
    public static apiAccountsLocationsTree(): CancelablePromise<LocationNode[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/locations/tree/',
        });
    }

    /**
     * HAND-ADDED: the free-text places already recorded on cases and people,
     * with whether the list covers each one. An empty location table nobody's
     * data matches is a table nobody maintains.
     * @returns any
     * @throws ApiError
     */
    public static apiAccountsLocationsInUse(): CancelablePromise<{ values: LocationInUse[]; unmatched: number }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/locations/in_use/',
        });
    }

    /**
     * HAND-ADDED: create a place.
     * @param requestBody
     * @returns Location
     * @throws ApiError
     */
    public static apiAccountsLocationsCreate(
requestBody: Partial<Location>,
): CancelablePromise<Location> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/admin/locations/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: edit a place.
     * @param id
     * @param requestBody
     * @returns Location
     * @throws ApiError
     */
    public static apiAccountsLocationsPartialUpdate(
id: number,
requestBody: Partial<Location>,
): CancelablePromise<Location> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/accounts/admin/locations/{id}/',
            path: { 'id': id },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: retire a place. Deactivates; nothing is deleted, because a
     * closed site is still where last year's permits happened.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiAccountsLocationsDelete(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/admin/locations/{id}/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: job positions.
     * @param search
     * @returns Position
     * @throws ApiError
     */
    public static apiAccountsPositionsList(
search?: string,
): CancelablePromise<Position[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/positions/',
            query: { 'search': search },
        });
    }

    /**
     * HAND-ADDED: create a position.
     * @param requestBody
     * @returns Position
     * @throws ApiError
     */
    public static apiAccountsPositionsCreate(
requestBody: Partial<Position>,
): CancelablePromise<Position> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/admin/positions/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: edit a position.
     * @param id
     * @param requestBody
     * @returns Position
     * @throws ApiError
     */
    public static apiAccountsPositionsPartialUpdate(
id: number,
requestBody: Partial<Position>,
): CancelablePromise<Position> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/accounts/admin/positions/{id}/',
            path: { 'id': id },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: retire a position.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiAccountsPositionsDelete(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/admin/positions/{id}/',
            path: { 'id': id },
        });
    }

    // ---- directory sync and Teams ------------------------------------------

    /**
     * HAND-ADDED: directory and Teams configuration, in one payload -- they
     * share an Entra application, so reporting them separately misleads.
     * @returns IntegrationStatus
     * @throws ApiError
     */
    public static apiAccountsIntegrationStatus(): CancelablePromise<IntegrationStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/integrations/status/',
        });
    }

    /**
     * HAND-ADDED: run a directory sync, or rehearse one.
     * A failed sync answers 200 carrying the reason: the run happened and is
     * recorded, and the client has a report to render.
     * @param requestBody
     * @returns SyncReport
     * @throws ApiError
     */
    public static apiAccountsDirectorySync(
requestBody: { dry_run: boolean; provider?: string },
): CancelablePromise<SyncReport> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/directory/sync/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: prove the directory credentials work, without syncing.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static apiAccountsDirectoryTest(
requestBody?: { provider?: string },
): CancelablePromise<{ ok: boolean; detail: string }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/directory/test/',
            body: requestBody ?? {},
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: past synchronisation runs, newest first.
     * @returns DirectorySyncRun
     * @throws ApiError
     */
    public static apiAccountsSyncRunsList(): CancelablePromise<DirectorySyncRun[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/sync-runs/',
        });
    }

    /**
     * HAND-ADDED: which groups the directory is allowed to touch.
     * @returns DirectoryGroupLink
     * @throws ApiError
     */
    public static apiAccountsGroupLinksList(): CancelablePromise<DirectoryGroupLink[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/admin/group-links/',
        });
    }

    /**
     * HAND-ADDED: let the directory manage one group's membership.
     * @param requestBody
     * @returns DirectoryGroupLink
     * @throws ApiError
     */
    public static apiAccountsGroupLinksCreate(
requestBody: { group: number; external_id: string; external_name?: string; source?: string },
): CancelablePromise<DirectoryGroupLink> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/admin/group-links/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: stop the directory managing a group. Its current members
     * stay -- unlinking is not emptying.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiAccountsGroupLinksDelete(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/admin/group-links/{id}/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: what a lookup field offers (C4). Signed-in rather than
     * staff-only: this is called while somebody is filling a case in.
     * The stored answer is the `code`, never the label -- a name gets renamed
     * and every stored answer stops resolving.
     * @returns the active entries of one list
     * @throws ApiError
     */
    public static apiCatalogEntityOptions(
type: string,
search?: string,
): CancelablePromise<Array<{ id: number; code: string; label: string }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/catalog/entities/options/',
            query: { 'type': type, 'search': search },
        });
    }

    /**
     * HAND-ADDED: the master-data lists an administrator has defined, for the
     * form designer's "which list?" picker.
     * @throws ApiError
     */
    public static apiCatalogEntityTypes(): CancelablePromise<Array<{
        id: number; code: string; name: string; is_hierarchical: boolean;
        entity_count: number;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/catalog/types/',
        });
    }

    /**
     * HAND-ADDED: the task inbox -- what this person owes, across every
     * process. Ordered most urgent first by the server (priority, then the
     * earliest deadline, undated work last), so a client never re-sorts.
     * @returns Task
     * @throws ApiError
     */
    public static apiMainTasksList(
params?: TaskListParams,
): CancelablePromise<{ count: number; results: Array<Task> } | Array<Task>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/tasks/',
            query: { ...(params || {}) },
        });
    }

    /**
     * HAND-ADDED: the counts the inbox header and the sidebar badge need.
     * @returns TaskSummary
     * @throws ApiError
     */
    public static apiMainTasksSummary(): CancelablePromise<TaskSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/tasks/summary/',
        });
    }

    /**
     * HAND-ADDED: take an unclaimed queue item. Also writes the section
     * assignment the rest of the product reads, so the pick means the same
     * thing wherever it was made.
     * @returns Task
     * @throws ApiError
     */
    public static apiMainTasksClaim(
id: number,
): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/tasks/{id}/claim/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: put a claimed queue item back in front of the whole pool.
     * @returns Task
     * @throws ApiError
     */
    public static apiMainTasksRelease(
id: number,
): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/tasks/{id}/release/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: hand one open task to somebody else. Group-owned sections
     * only -- an approval slot names the person whose authority is being
     * exercised, and a Requester section belongs to whoever raised the case.
     * @returns Task
     * @throws ApiError
     */
    public static apiMainTasksReassign(
id: number,
userId: string,
): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/tasks/{id}/reassign/',
            path: { 'id': id },
            body: { user_id: userId },
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: cover (D2). A person's own delegations, both directions --
     * who is covering for them and whose work they hold. An administrator
     * passing `scope=all` sees everybody's.
     * @returns Delegation
     * @throws ApiError
     */
    public static apiAccountsDelegationsList(
scope?: 'all',
): CancelablePromise<Delegation[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/delegations/',
            query: { scope },
        });
    }

    /**
     * HAND-ADDED: arrange cover. Only for your own work, unless you are an
     * administrator -- the server decides, not this method.
     * @returns Delegation
     * @throws ApiError
     */
    public static apiAccountsDelegationsCreate(
body: DelegationWrite,
): CancelablePromise<Delegation> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/delegations/',
            body,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: change the dates, scope or reason of existing cover. The two
     * people are not editable -- that is a different arrangement.
     * @returns Delegation
     * @throws ApiError
     */
    public static apiAccountsDelegationsUpdate(
id: number,
body: Partial<DelegationWrite>,
): CancelablePromise<Delegation> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/accounts/delegations/{id}/',
            path: { 'id': id },
            body,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: end cover. Deactivates and dates the row rather than
     * deleting it (invariant 2) -- an audit entry may point at it.
     * @throws ApiError
     */
    public static apiAccountsDelegationsDelete(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/delegations/{id}/',
            path: { 'id': id },
        });
    }

    /**
     * HAND-ADDED: raise or lower one task in the queue. 10 low, 20 normal,
     * 30 high.
     * @returns Task
     * @throws ApiError
     */
    public static apiMainTasksPrioritise(
id: number,
priority: number,
): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/tasks/{id}/prioritise/',
            path: { 'id': id },
            body: { priority },
            mediaType: 'application/json',
        });
    }

}
